"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = __importDefault(require("react-dom"));
var prop_types_1 = __importDefault(require("prop-types"));
var Portal = function (props) {
    var children = props.children, container = props.container;
    var mountNode = container || document.body;
    return react_dom_1.default.createPortal(children, mountNode);
};
Portal.propTypes = {
    children: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    container: prop_types_1.default.any
};
Portal.defaultProps = {
    container: null
};
exports.default = Portal;
//# sourceMappingURL=Portal.js.map